import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Medewerker } from "../../../entities/Medewerker";
import { Avatar } from "@material-ui/core";


interface MedewerkerInfo {
  fullName: string;
  isActive: boolean;
}

// All the incoming values
interface IProps {
    medewerker: MedewerkerInfo;
    size?: "small" | "medium" | "large";
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const MedewerkerAvatar = (props: AllProps) => {
    const classes = useStyles(useTheme(), props.medewerker.isActive ? Medewerker.getAvatarColor(props.medewerker.fullName) : useTheme().palette.grey[300]);    
    const size = props.size || "medium";

    const avatarSize = size === "small" ? classes.small : size === "large" ? classes.large : classes.medium;

    return <Avatar className={avatarSize} alt={props.medewerker.fullName} >
        {props.medewerker.fullName.split(' ')[0].charAt(0).toUpperCase() + props.medewerker.fullName.split(' ')[1].charAt(0).toUpperCase()}
    </Avatar>
}

// CSS
const useStyles =(theme: Theme, avatarColor: string) => { 
  
  
  const style =  makeStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      fontSize: theme.spacing(1.5),
      backgroundColor: avatarColor,
      color: theme.palette.getContrastText(avatarColor),
    },
    medium: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      fontSize: theme.spacing(2),
      backgroundColor: avatarColor,
      color: theme.palette.getContrastText(avatarColor),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      fontSize: theme.spacing(3),
      backgroundColor: avatarColor,
      color: theme.palette.getContrastText(avatarColor),
    },
  }))
  return style(theme);
};